export default {
  tablelogin: [
    {
      path: "/curriculum",
      iconStyle: imagepaths.Dashboard,
      iconActive: imagepaths.DashboardActive,
      label: "Curriculum",
    },
  ]
};